"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var apiUser = _interopRequireWildcard(require("@/api/user"));

var apiPermission = _interopRequireWildcard(require("@/api/permission"));

var _saveState = _interopRequireDefault(require("@/mixins/saveState.js"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  data: function data() {
    return {
      permissions: [],
      data: [],
      currentPage: 1,
      pageSize: 20,
      multipleSelection: [],
      // --
      filters: [{
        value: '',
        prop: ['lastname', 'firstname', 'email', 'role']
      }],
      filterRole: [],
      filterActif: [],
      sortColumn: [],
      refresh: 0
    };
  },
  mixins: [_saveState.default],
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {
    idSociete: function idSociete() {
      return this.user.id_societe;
    },
    total: function total() {
      return this.data ? this.data.length : 0;
    },
    filter: {
      get: function get() {
        return this.filters ? this.filters[0].value : null;
      },
      set: function set(newValue) {
        this.filters[0].value = newValue;
      }
    }
  }),
  beforeMount: function beforeMount() {
    this.loadData();
  },
  methods: {
    sortDatatable: function sortDatatable() {
      var field = this.sortColumn.column || 'lastname';
      var order = this.sortColumn.order || 'ascending';

      if (order === 'ascending') {
        this.data.sort(function (a, b) {
          return a[field] < b[field] ? -1 : 1;
        });
      } else {
        this.data.sort(function (a, b) {
          return b[field] < a[field] ? -1 : 1;
        });
      }
    },
    loadData: function () {
      var _loadData = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this = this;

        var dta, _iterator, _step, _loop;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$loader(true);
                this.data = [];
                this.filterRole = [];
                this.filterActif = [];
                this.sortColumns = [];
                _context.next = 7;
                return apiPermission.getAllBySocieteId(this.idSociete);

              case 7:
                this.permissions = _context.sent;
                _context.next = 10;
                return apiUser.getAllBySocieteId(this.idSociete);

              case 10:
                dta = _context.sent;

                if (dta && dta.length > 0) {
                  _iterator = _createForOfIteratorHelper(dta);

                  try {
                    _loop = function _loop() {
                      var row = _step.value;
                      row.enabled = row.enabled === 1 ? '✓' : '✗';

                      var permission = _this.permissions.find(function (x) {
                        return x.key_role === row.key_role;
                      });

                      row.role = permission ? permission.name : '';

                      _this.data.push(row); // ---


                      if (!_this.filterRole.find(function (x) {
                        return x.value === row.role;
                      })) {
                        _this.filterRole.push({
                          text: row.role,
                          value: row.role
                        });
                      }

                      if (!_this.filterActif.find(function (x) {
                        return x.value === row.enabled;
                      })) {
                        _this.filterActif.push({
                          text: row.enabled,
                          value: row.enabled
                        });
                      }
                    };

                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      _loop();
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  this.sortDatatable();
                }

                this.$loader(false);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadData() {
        return _loadData.apply(this, arguments);
      }

      return loadData;
    }(),
    getSaveStateConfig: function getSaveStateConfig() {
      return {
        'cacheKey': 'dataTables',
        'saveProperties': ['currentPage', 'pageSize', 'filters', 'sortColumn']
      };
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange: function handleSortChange(column, prop, order) {
      this.sortColumn = {
        column: column.prop,
        order: column.order
      };
      this.sortDatatable();
    },
    handleFilterChange: function handleFilterChange(filter) {},
    filterHandler: function filterHandler(value, row, column) {
      var property = column['property'];
      return row[property] === value;
    },
    handleDelete: function handleDelete(index, row) {
      var _this2 = this;

      this.$confirm('Voulez-vous supprimer l\'utilisateur ' + row.firstname + ' ' + row.lastname + ' ?', 'Confirmer la suppression', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        _this2.$loader(true);

        apiUser.deleteById(row.id).then(function (results) {
          _this2.data.splice(_this2.data.indexOf(row), 1);

          _this2.$message('Suppression effectuée avec sucès');

          _this2.$loader(false);
        }).catch(function (err) {
          _this2.$message(err);

          _this2.$loader(false);
        });
      });
    },
    handleDeleteSelection: function handleDeleteSelection() {
      var _this3 = this;

      var msg = this.multipleSelection.length > 1 ? 'les lignes sélectionnées' : 'la ligne sélectionnée';
      this.$confirm('Voulez-vous supprimer ' + msg + ' ?', 'Confirmer la suppression', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        _this3.$loader(true);

        var selection = _this3.multipleSelection.map(function (u) {
          return u.id;
        }).join(',');

        apiUser.bulkDelete(selection).then(function (results) {
          _this3.$message('Suppression effectuée avec succès');

          _this3.loadData();

          _this3.$loader(false);
        }).catch(function (error) {
          _this3.$message(error);

          _this3.$loader(false);
        });
      });
    }
  }
};
exports.default = _default;